import React from "react";
import { Tag } from "antd";
import { formatPrice } from "@/utils/utils";
export default function DryRunTag({ price }) {
    return (React.createElement(Tag, { color: "red", style: { marginLeft: 8 } },
        "Dry Run",
        price ? `: ${formatPrice(price)}` : ": $0.00"));
}
DryRunTag.defaultProps = {
    price: undefined,
};
